export default "__VITE_ASSET__C4eIR4xR__"